import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config'; // Make sure this resolves correctly
import { useQuery,useQueryClient } from '@tanstack/react-query';
import { toast, ToastContainer } from 'react-toastify';
import ReactModal from 'react-modal';
import { useLocation, useNavigate } from 'react-router-dom';


function FamilyTreeSpouse() {
    const location = useLocation();
  const memberId = location.state?.memberId;

  const loggedInUserId = localStorage.getItem("user_id");
    const loggedFamilyAdmin = localStorage.getItem("family_admin");

  //console.log("Received ID:", memberId);

  const navigate = useNavigate();

    const { menu, toggleMobileMenu } = useAppLayout();
    const chartContainerRef = useRef(null);
  const chartInstanceRef = useRef(null);

  const queryClient = useQueryClient();

  const getToken = () => localStorage.getItem('token');


  //automatically save member_id

  const hasPostedRef = useRef(false);

useEffect(() => {
  if (memberId && !hasPostedRef.current) {
    hasPostedRef.current = true;

    axios.post(`${API_URL}/family-tree-save-spouse-member-id`, { memberId })
      .then((response) => {
        // toast.success('Member ID saved successfully!');
      })
      .catch((error) => {
        console.error('Error saving ID:', error);
        toast.error('Failed to save member ID');
      });
  }
}, [memberId]);


  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState({
    id: '',
    name: '',
    alt_name: '',
    img: '',
    gender: '',
    married: '',
    single: '',
    single_mother: '',
    spouse: '',
    unknown: '',
  });


const openModalWithData = (data) => {
  setSelectedMember({
    id: data.id || '',
    name: data.name || '',
    alt_name: data.alt_name || '',
    img: data.img || '',
    gender: data.gender || '',
    married: data.married || '',
    single: data.single || '',
    single_mother: data.single_mother || '',
    spouse: data.spouse || '',
    unknown: data.unknown || '',
  });
  setModalIsOpen(true);
};


 // Query to fetch family tree data

  const { data: familyTreeData, isLoading: isLoadingFamilyTree, isError: isErrorFamilyTree } = useQuery({
    queryKey: ['familyTree', memberId], // track query by memberId too
    queryFn: () =>
      axios
        .get(`${API_URL}/family-tree-spouse`, {
          params: { memberId }, // pass memberId as query param
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        })
        .then((res) => res.data),
    enabled: !!memberId, // only run when memberId is available
    staleTime: 0,
    cacheTime: Infinity,
  });


   // Load OrgChart script when data is available
   useEffect(() => {
    if (!familyTreeData) return; // Wait for data to be available

    loadScript(`${process.env.PUBLIC_URL}/orgchart/orgchart.js`)
      .then(() => {
        initializeOrgChart(familyTreeData);
        //console.log("family TreeData:", familyTreeData);
      })
      .catch((error) => {
        console.error('Failed to load OrgChart script:', error);
      });

    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }
    };
  }, [familyTreeData]); // Runs only when familyTreeData is updated




  const [addFamilyModalIsOpen, setAddFamilyModalIsOpen] = useState(false);

  const openAddFamilyModal = () => {
    setAddFamilyModalIsOpen(true);
  };
  
  const closeAddFamilyModal = () => {
    setAddFamilyModalIsOpen(false);
  };

  
  //check if father/mother is added
  const [hasFather, setHasFather] = useState(false);
const [hasMother, setHasMother] = useState(false);

useEffect(() => {
  if (selectedMember?.id) {
    axios.post(`${API_URL}/family-tree-spouse-check-father-mother-api`, {
      selected_id: selectedMember.id
    }, { withCredentials: true })
      .then(res => {
        setHasFather(res.data.hasFather);
        setHasMother(res.data.hasMother);
      })
      .catch(err => {
        console.error("Error fetching parent info:", err);
      });
  }
}, [selectedMember]);


const getRelationshipOptions = () => {
  const { gender, married, single, single_mother } = selectedMember || {};

  let baseOptions = [];


  if (gender === 'Male') {
    baseOptions = ['Father', 'Mother', 'Spouse', 'Brother', 'Sister', 'Son', 'Daughter'];
  } else if (gender === 'Female') {
    baseOptions = ['Father', 'Mother', 'Brother', 'Sister'];
  }

  // Logic to conditionally remove "Father" or "Mother"
  if (hasFather && hasMother) {
    baseOptions = baseOptions.filter(rel => rel !== 'Father' && rel !== 'Mother');
  } else if (hasFather && !hasMother) {
    baseOptions = baseOptions.filter(rel => rel !== 'Father');
  } else if (!hasFather && !hasMother) {
    baseOptions = baseOptions.filter(rel => rel !== 'Mother'); // show only Father
  }

  // Step 2: Remove Step-Mother if not both parents are present
  if (!(hasFather && hasMother)) {
    baseOptions = baseOptions.filter(rel => rel !== 'Step-Mother');
  }
  

  return baseOptions;
};




  const [selectedRelationship, setSelectedRelationship] = useState('');
  const [isDeceased, setIsDeceased] = useState(false);
  const [selectedPrefix, setSelectedPrefix] = useState("");


  const getPrefixOptions = () => {

    const maleRelations = ['Father', 'Son', 'Brother'];
    const femaleRelations = ['Mother', 'Daughter', 'Sister', 'Spouse'];
  
    const neutral = ['Dr', 'Prof', 'Rev'];
  
    if (maleRelations.includes(selectedRelationship)) {
      return ['Mr', ...neutral];
    }
  
    if (femaleRelations.includes(selectedRelationship)) {
      return ['Mrs', ...neutral];
    }
  
    // Default
    return ['Mr', 'Mrs', ...neutral];
  };


  const loadScript = (src) => {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });
  };

  const initializeOrgChart = (data) => {
    if (!window.OrgChart) return;
    const isMobile = window.innerWidth <= 768;
    const OrgChart = window.OrgChart;

    OrgChart.templates.family_template = Object.assign({}, OrgChart.templates.ana);
    OrgChart.templates.family_template.size = [86, 86];
    OrgChart.templates.family_template.plus = '';
    OrgChart.templates.family_template.minus = '';
    OrgChart.templates.family_template.rippleRadius = 40;
    OrgChart.templates.family_template.name = '<text style="font-size: 12px;" fill="#000000" x="43" y="100" text-anchor="middle">{val}</text>';
    OrgChart.templates.family_template.title = '<text style="font-size: 12px;" fill="#aeaeae" x="43" y="115" text-anchor="middle">{val}</text>';
    OrgChart.templates.family_template.img = '<clipPath id="{randId}"><circle cx="43" cy="43" r="38.5"></circle></clipPath></circle><image preserveAspectRatio="xMidYMid slice" clip-path="url(#{randId})" xlink:href="{val}" x="3" y="3" width="80" height="78"></image>';
    OrgChart.templates.family_template.node = '<circle stroke-width="3" fill="none" stroke="#FF1493" cx="43" cy="43" r="41.5"></circle>';

    OrgChart.templates.family_template_blue = Object.assign({}, OrgChart.templates.family_template);
    OrgChart.templates.family_template_blue.node = '<circle stroke-width="3" fill="none" stroke="#039BE5" cx="43" cy="43" r="41.5"></circle>';

    const chart = new OrgChart(chartContainerRef.current, {
      template: 'family_template',
      enableSearch: true,
      levelSeparation: isMobile ? 60 : 100,
      siblingSeparation: isMobile ? 60 : 100,
      scaleInitial: isMobile ? OrgChart.match.boundary : 1,
      scaleMin: 0.5,
      scaleMax: 3,
      
      nodeBinding: {
        name: 'name',
        title: 'title',
        img: 'img',
        
      },
      tags: {
        blue: { template: 'family_template_blue' },
        partner: { template: 'family_template' },
      },

      nodeMouseClick: OrgChart.action.none, // override default popup

    });

    chart.on('render-link', (sender, args) => {
      if (args.cnode.ppid !== undefined) {
        args.html += '<use xlink:href="#baby" x="' + args.p.xa + '" y="' + args.p.ya + '"/>';
      }
    });

    chart.on('redraw', function () {
      const chartElement = document.querySelector('#tree svg');
      if (chartElement) {
        chartElement.style.touchAction = 'pan-x pan-y';
      }
    });

    /*chart.on('click', (sender, args) => {
      if (args && args.node) {
        const nodeData = sender.get(args.node.id); // Gets the full node data from the chart
        openModalWithData(nodeData);
      }
    });*/

    chart.on('click', (sender, args) => {
      if (args && args.node) {
        const nodeData = sender.get(args.node.id);
        setTimeout(() => {
          openModalWithData(nodeData);
        }, 150); // Slight delay fixes the flash
      }
    });

    chart.load(data);
    chartInstanceRef.current = chart;
  };


//spouse list
const [spouseList, setSpouseList] = useState([]);
useEffect(() => {
  if (addFamilyModalIsOpen && selectedMember) {
    fetchSpouses();
  }
}, [addFamilyModalIsOpen, selectedMember]);

const fetchSpouses = async () => {
  try {
    const response = await axios.post(`${API_URL}/family-tree-spouse-get-spouse-api`, {
      withCredentials: true,
      selected_id: selectedMember.id,
    });
    setSpouseList(response.data);
  } catch (error) {
    console.error('Error fetching spouses:', error);
  }
};
//


//mother list
const [motherList, setMotherList] = useState([]);
useEffect(() => {
  if (addFamilyModalIsOpen && selectedMember) {
    fetchMothers();
  }
}, [addFamilyModalIsOpen, selectedMember]);

const fetchMothers = async () => {
  try {
    const response = await axios.post(`${API_URL}/family-tree-spouse-get-mother-api`, {
      withCredentials: true,
      selected_id: selectedMember.id,
    });
    setMotherList(response.data);
  } catch (error) {
    console.error('Error fetching mothers:', error);
  }
};
//


//image preview
const [imageFile, setImageFile] = useState(null);
const [previewImage, setPreviewImage] = useState(null);
  
 //submit member details
 const [formData, setFormData] = useState({
  name: '',
  last_name: '',
  surname: '',
  gender: '',
  date_of_birth: '',
  date_of_death: '',
  relationship: '',
  prefix: '',
  deceased: false,
  selected_id: '',
  mother_id: ''
  
});


useEffect(() => {
  if (selectedMember) {
    setFormData((prev) => ({
      ...prev,
      selected_id: selectedMember.id, 
    }));
  }
}, [selectedMember]);




// Helper to reset the form
const resetForm = () => {
  setFormData({
    name: '',
    last_name: '',
    surname: '',
    gender: '',
    date_of_birth: '',
    date_of_death: '',
    relationship: '',
    prefix: '',
    deceased: false,
    selected_id: selectedMember?.id || '', // optionally preserve selected_id
    mother_id: ''
  });
  setImageFile(null);
  setSelectedRelationship('');
  setSelectedPrefix('');
  setIsDeceased(false);
};


const [isSubmitting, setIsSubmitting] = useState(false);

const handleSubmitMemberDetails = async () => {
  // Validation: Required relationship
  if (!formData.relationship) {
    toast.error("Relationship is required", { position: "top-right", autoClose: 3000 });
    return;
  }

  const needsMotherId = ['Brother', 'Sister', 'Son', 'Daughter'].includes(formData.relationship);
  const isSingleMother = selectedMember?.single_mother === 1 || selectedMember?.single_mother === '1';

  if (needsMotherId && !formData.mother_id && !isSingleMother) {
    toast.error("Mother is required for this relationship", { position: "top-right", autoClose: 3000 });
    return;
  }

  if (!formData.name) {
    toast.error("First name is required", { position: "top-right", autoClose: 3000 });
    return;
  }


  //Start submission only if all validation passes
  setIsSubmitting(true);
  const submissionData = new FormData();

  // Mother ID
  if (needsMotherId) {
    submissionData.append('mother_id', isSingleMother ? '0' : formData.mother_id);
  }

  // Append regular fields
  for (const key in formData) {
    if (
      key !== 'deceased' &&
      key !== 'mother_id'
    ) {
      if (formData[key] !== undefined && formData[key] !== null) {
        submissionData.append(key, formData[key]);
      }
    }
  }

  // Append special fields
  submissionData.append('deceased', formData.deceased ? '1' : '0');

  if (imageFile) {
    submissionData.append('image', imageFile);
  }

  if (selectedMember?.id) {
    submissionData.append('selected_member_id', selectedMember.id);
  }

  if (memberId) {
    submissionData.append('member_id', memberId);
  }

  try {
    const response = await axios.post(
      `${API_URL}/family-tree-spouse-add-member-api`,
      submissionData,
      { withCredentials: true }
    );

    if (response.data.success) {
      queryClient.invalidateQueries(['familyTree']);
      closeAddFamilyModal();
      setModalIsOpen(false);
      toast.success("Family member added successfully", { position: "top-right", autoClose: 3000 });
      
      resetForm();
    } else {
      toast.error(response.data.message || "Failed to add member", { position: "top-right", autoClose: 3000 });
    }
  } catch (error) {
    console.error('Error submitting form:', error);
    const backendMsg = error.response?.data?.message || error.message;
    toast.error(backendMsg || "An error occurred while adding member.", {
      position: "top-right",
      autoClose: 3000,
    });
  } finally {
    setIsSubmitting(false); // Re-enable submit button
  }
};


//family info
const {
  data: familyInfo = [],          // default to empty array
  isLoadingInfo,
  isErrorInfo,
} = useQuery({
  queryKey: ['familyInfo', memberId],
  queryFn: () =>
    axios
      .get(`${API_URL}/family-info-spouse`, {
        params: { memberId },     // <-- only the query‑param
        withCredentials: true,    // keep if you rely on cookies; else drop
      })
      .then(res => res.data),
  enabled: !!memberId,            // guard against undefined id
});

//end family info

//save family info
const [infoModalOpen, setInfoModalOpen] = useState(false);


const [formDataInfo, setFormDataInfo] = useState({
  tribe: '',
  subtribe: '',
  subgroup: '',
  clan: '',
  totem: '',
  family: '',
});

//
const handleOpenFamilyInfoModal = () => {
  if (familyInfo.length > 0) {
    setFormDataInfo(familyInfo[0]); // Load existing values into form
  } else {
    setFormDataInfo({ tribe: '', subtribe: '', subgroup: '', clan: '', totem: '', family: '' });
  }
  setInfoModalOpen(true);
};
//

const isUpdating = familyInfo.length > 0;

const handleSaveFamilyInfo = () => {
  const { tribe } = formDataInfo;
  if (!tribe.trim()) {
    toast.error("Tribe is required");
    return;
  }

  axios.post(`${API_URL}/save-family-info-spouse`, {
    ...formDataInfo,
    user_id: memberId,
  }, { withCredentials: true })
    .then(() => {
      toast.success(isUpdating ? "Family info updated successfully" : "Family info saved successfully");
      setInfoModalOpen(false);
      setFormDataInfo({ tribe: '', subtribe: '', subgroup: '', clan: '', totem: '', family: '' });
      queryClient.invalidateQueries(['familyInfo', memberId]);
    })
    .catch(err => {
      console.error("Error saving family info:", err);
      toast.error("Error saving family info");
    });
};





  if (isLoadingFamilyTree) return( 
    <div className='loadingspinnerDiv'>
    <div className='loadingspinner'></div>
    
  </div>
     );
  
  if (isErrorFamilyTree) return <p>Error loading family tree data.</p>;


  return (
    <div className={`main-wrapper ${menu ? 'slide-nav': ''}`}>
      <Header onMenuClick={(value) => toggleMobileMenu()} />
      <Sidebar />
        <ToastContainer />

        <div className="page-wrapper">
        <div className="content container-fluid">

          
        <div className='row'>
            <div className='col-md-4'>
                <p style={{fontWeight: 900}}>Family Info</p>
                <button className="btn btn-primary mb-3" onClick={handleOpenFamilyInfoModal}>Update Family Info</button>
                

                {isLoadingInfo && <p>Loading…</p>}
      {isErrorInfo && <p className="text-danger">Couldn’t load data.</p>}

      {familyInfo.length > 0 ? (
        <ul className="list-group">
          {familyInfo.map(
            ({ id, tribe, subtribe, subgroup, clan, totem, family }) => (
              <li key={id} className="list-group-item">
                <strong>Tribe:</strong> {tribe} <br />
                <strong>Sub‑tribe:</strong> {subtribe} <br />
                <strong>Sub‑group:</strong> {subgroup || '—'} <br />
                <strong>Clan:</strong> {clan || '—'} <br />
                <strong>Totem:</strong> {totem || '—'} <br />
                <strong>Family:</strong> {family || '—'}
              </li>
            )
          )}
        </ul>
      ) : (
        !isLoadingInfo && !isErrorInfo && <p>No family information found.</p>
      )}


<ReactModal isOpen={infoModalOpen} onRequestClose={() => setInfoModalOpen(false)} className="Modal" overlayClassName="Overlay">
    <div className="modal-header">
      <h5 className="modal-title">Add Family Info</h5>
      <button type="button" className="btn-close modalCloseButton" onClick={() => setInfoModalOpen(false)}></button>
    </div>

    <div className="modal-body">
      <div className="row">
        {['tribe', 'subtribe', 'subgroup', 'clan', 'totem', 'family'].map(field => (
          <div className="col-6 col-md-6 mb-3" key={field}>
            <label className="form-label text-capitalize">{field}</label>
            <input
                type="text"
                className="form-control"
                name={field}
                value={formDataInfo[field]}  // ← fix here
                onChange={(e) =>
                  setFormDataInfo((prev) => ({ ...prev, [field]: e.target.value }))  // ← fix here
                }
                required={['tribe', 'subtribe'].includes(field)}
              />
          </div>
        ))}
      </div>
    </div>

    <div className="modal-footer">
      <button className="btn btn-primary" onClick={handleSaveFamilyInfo}>
        Save Info
      </button>
    </div>
  </ReactModal>


            </div>

            
            
            <div className='col-md-8' style={{backgroundColor: '#fdf5e6'}}>  
      
        <div id="tree" ref={chartContainerRef} style={{ width: '100%', height: '600px' }}></div>

        <ReactModal 
  isOpen={modalIsOpen} 
  onRequestClose={() => setModalIsOpen(false)} 
  className="Modal" 
  overlayClassName="Overlay"
  ariaHideApp={false} >
  <div className="modal-header" style={{backgroundColor: '#ffff', height: '40px'}}>
    <h5 className="modal-title"></h5>
    <button type="button" className="btn-close modalCloseButton" onClick={() => setModalIsOpen(false)}></button>
  </div>

  <div className="modal-body" style={{padding: '0'}}>
    <div className="row">
      <div className="col-12 col-md-12">

      <div style={{height: '300px', overflow: 'hidden'}}>
      {selectedMember.img && (

        <img
          src={selectedMember.img}
          alt={selectedMember.name}
          style={{ height: '300px', width: '100%', objectFit: 'cover', marginBottom: '15px' }}
        />
      )}

    </div>

    <center>
      <h2 style={{ marginTop: '2%'}}>{selectedMember.name}</h2>
      
      
      </center>
      </div>
    </div>
  </div>

  <div className="row" style={{paddingBottom: '5%'}}>
    <div className="col-5 col-md-5" >

    {(selectedMember.unknown === "" && selectedMember.spouse === "") ? (
  <button
    type="submit"
    name="btn_extend_family"
    className="btn btn-outline-secondary font-size1"
    style={{ marginLeft: '5%' }}
    onClick={openAddFamilyModal}
  >
    <i className="fa fa-plus"></i> Add Family
  </button>
) : null }
      
    </div>
    
    <div className="col-3 col-md-3">
    {( parseInt(loggedInUserId) === parseInt(selectedMember.id) ||
                      loggedFamilyAdmin === "1" ) && (
    <button type="submit" name="btn_edit_profile" class="btn btn-outline-secondary edit_user font-size1"
    onClick={() => navigate('/edit-personal-info-spouse', { state: { editMemberId: selectedMember.id, memberId: memberId } })}
    >
      <i class="fa fa-edit"></i> Edit</button>
                      )}
      </div>
      <div className="col-4 col-md-4">


      </div>
    
  </div>
</ReactModal>




<ReactModal 
  isOpen={addFamilyModalIsOpen}
  onRequestClose={closeAddFamilyModal}
  className="Modal2"
  overlayClassName="Overlay"
  ariaHideApp={false} >
  <div className="modal-header" style={{ height: '40px'}}>
    <p className="modal-title">Add family member to <b>{selectedMember?.name}</b></p>
    <button type="button" className="btn-close modalCloseButton" onClick={closeAddFamilyModal}></button>
  </div>

  <div className="modal-body">

<div className="row">
  <div className="col-md-12">
    <center>
      <div
        className="position-relative d-inline-block"
        style={{ cursor: 'pointer' }}
        onClick={() => document.getElementById('uploadImageInput').click()}
      >
        <div className="">
          <img
            src={previewImage || 'img/avatar_male.png'} // fallback image
            alt="Preview"
            style={{
              width: '100px',
              height: '100px',
              objectFit: 'cover',
              borderRadius: '50%',
              border: '2px solid #ccc'
            }}
          />
        </div>
        <span
          className="avatar-edit bg-transparent shadow-none"
          style={{
            position: 'absolute',
            bottom: '5px',
            right: '5px',
            backgroundColor: '#fff',
            borderRadius: '50%',
            padding: '6px',
            boxShadow: '0px 0px 5px rgba(0,0,0,0.2)'
          }}
        >
          <i className="fas fa-edit" style={{ color: '#184A2C', fontSize: '16px' }}></i>
        </span>
        <input
          id="uploadImageInput"
          type="file"
          accept="image/*"
          style={{ display: 'none' }}
          onChange={(e) => {
            const file = e.target.files[0];
            if (file) {
              setImageFile(file);
              const reader = new FileReader();
              reader.onloadend = () => {
                setPreviewImage(reader.result);
              };
              reader.readAsDataURL(file);
            }
          }}
        />
      </div>
    </center>
  </div>
</div>


    <div className='row'>
      <div className='col-6 col-md-6'>
      
        <>
        <label className="form-label">Select to Add</label>
        <select
          name="relationship"
          className="form-control"
          value={formData.relationship}
          onChange={(e) => setFormData({ ...formData, relationship: e.target.value })}
        >
          <option value="">Select to Add</option>
          {getRelationshipOptions().map((relation) => (
            <option key={relation} value={relation}>{relation}</option>
          ))}
        </select>
        </>


        
        
      </div>
      
      <div className='col-6 col-md-6'>
       

      {(formData.relationship === 'Brother' || formData.relationship === 'Sister') && (
  <>
    <label>Select Mother</label>
    <select
      className="form-control"
      value={formData.mother_id || ''}
      onChange={(e) => setFormData({ ...formData, mother_id: e.target.value })}
    >
      <option value="">Select Mother</option>
      {motherList.map((mother) => (
        <option key={mother.id} value={mother.id}>{mother.name}</option>
      ))}
    </select>
  </>
)}

{(formData.relationship === 'Son' || formData.relationship === 'Daughter'  && selectedMember.gender === 'Male') && (
  <>
    <label>Select Mother</label>
    <select
      className="form-control"
      value={formData.mother_id || ''}
      onChange={(e) => setFormData({ ...formData, mother_id: e.target.value })}
    >
      <option value="">Select Mother</option>
      {spouseList.map((spouse) => (
        <option key={spouse.id} value={spouse.id}>{spouse.name}</option>
      ))}
    </select>
  </>
)}

 
      </div>
    </div>

    <div className='row'>
      <div className='col-6 col-md-6'>
        <label>Prefix</label>
        <select
          className="form-control"
          value={formData.prefix}
          onChange={(e) => setFormData({ ...formData, prefix: e.target.value })}
        >
          <option value="">Select Prefix</option>
          {getPrefixOptions().map((prefix) => (
            <option key={prefix} value={prefix}>{prefix}</option>
          ))}
        </select>
      </div>
      
      <div className='col-6 col-md-6'>
        <label>First Name</label>
        <input
          type="text"
          name="name"
          className="form-control"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          required
        />
      </div>
    </div>

    <div className='row'>
      <div className='col-6 col-md-6'>
        <label>Last Name</label>
        <input
          type="text"
          name="last_name"
          className="form-control"
          value={formData.last_name}
          onChange={(e) => setFormData({ ...formData, last_name: e.target.value })}
        />
      </div>

      <div className='col-6 col-md-6'>
        <label>Surname</label>
        <input
          type="text"
          name="surname"
          className="form-control"
          value={formData.surname}
          onChange={(e) => setFormData({ ...formData, surname: e.target.value })}
        />
      </div>
    </div>

    <div className='row'>
      <div className='col-6 col-md-6'>
        <label>Status</label><br />

        <input
          type="checkbox"
          name="deceased"
          className="form-check-input me-2"
          checked={formData.deceased}
          onChange={() => {
            setFormData((prev) => ({
              ...prev,
              deceased: !prev.deceased
            }));
          }}
        /> Deceased<br />

      </div>

      <div className='col-6 col-md-6'>
        <label>Date of Birth</label>
        <input
          type="date"
          name="date_of_birth"
          className="form-control"
          value={formData.date_of_birth}
          onChange={(e) => setFormData({ ...formData, date_of_birth: e.target.value })}
        />

        {formData.deceased && (
          <>
            <label>Date of Death</label>
            <input
              type="date"
              name="date_of_death"
              className="form-control"
              value={formData.date_of_death}
              onChange={(e) => setFormData({ ...formData, date_of_death: e.target.value })}
            />
          </>
        )}
      </div>
    </div>

  </div>

  <div className="modal-footer">

    <button onClick={handleSubmitMemberDetails} className="btn btn-primary"
    disabled={isSubmitting}>
  {isSubmitting ? "Saving..." : "Save Member Details"}
</button>

  </div>
</ReactModal>


        </div>
        </div>


      </div>
      </div>
      
    </div>
    
  );
}

export default FamilyTreeSpouse;
